export default __webpack_public_path__ + "static/media/rafa1.7bcfde9b.jpg";